import { ReplacementRentalCarResponse } from "../reducers/reducer-replacement-rental-car-questions";
import { refreshReducersToInitial } from "./refreshData-action";

export const UPDATE_REPLACEMENT_RENTAL_CAR_QUESTIONS = "UPDATE_REPLACEMENT_RENTAL_CAR_QUESTIONS" as const;
export const CLEAR_REPLACEMENT_RENTAL_CAR_QUESTIONS = "CLEAR_REPLACEMENT_RENTAL_CAR_QUESTIONS" as const;

export const updateReplacementRentalCar = (payload: ReplacementRentalCarResponse) =>
  ({
    type: UPDATE_REPLACEMENT_RENTAL_CAR_QUESTIONS,
    payload,
  } as const);

export const clearReplacementRentalCar = () =>
  ({
    type: CLEAR_REPLACEMENT_RENTAL_CAR_QUESTIONS,
  } as const);

export type ReplacementRentalCarActions =
  | ReturnType<typeof updateReplacementRentalCar>
  | ReturnType<typeof clearReplacementRentalCar>
  | ReturnType<typeof refreshReducersToInitial>;
